export default {
  email: "Email",
  language: "Language",
  currencyLanguage: "EN(English)",
  contactUs: "Contact Us",
  services: "Services",
  download: "Download",
  more: "More",
  successfulCustomer: "Successful Customer",
  weChatOfficialAccount: "WeChat Official Account",
  businessDiscussion: "Business Discussion",
  leaveAMessage: "Leave A Message",
  thankMessage:
    "Thank you for your attention, if you want to consult any matter, please fill in your information below, we will contact you as soon as possible",
  name: "Name(require)",
  phone0: "Phone",
  phone: "Tel(require)",
  company: "Company Name(require)",
  consultingProducts:'Consulting products(remark)',
  submit: "Submit",
  home: "Home",
  contactWay: "Contact Way",
  characteristic: "Characteristic",
  ICP: "ICP",
  apply: "Apply",
  talentRecruitment: "Talent Recruitment",
  history: "History",
  noImage:'No Images',
  noData:'No Data',

  // 路由----------------------------
  ProductList: "Products",
  ProductDetail: "Product Detail",
  SolutionPage: "Solution",
  TechnicalSupport: "Technical Support",
  Jobs: "Jobs",
  News: "News",
  ContactUs: "Contact Us",
  About: "About Binar Handling",
  DownloadFile: "File Download",
  ApplicationDetail:"Application",
  Search:'Search',
  PreviewPdf:'Preview',
  DownloadVideo:'Video',
  // ------------------------------------
  
  //jobs
  AllJobs:"All Jobs",

  // Mobile----------------------------
  backToMainMenu:'Back to Main Menu',
  selectLanguage:'Select Language',
  goBack:'Go Back',
  // ------------------------------------

};
